import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const app = initializeApp({
    apiKey: "AIzaSyCuplRthVDHRBsq9UlyJpez2ySGS2NmVO4",
    authDomain: "svik-app.firebaseapp.com", 
    projectId: "svik-app",
    storageBucket: "svik-app.appspot.com",
    messagingSenderId: "86982641345",
    appId: "1:86982641345:web:19e6a899b6cf8fd6873640",
    measurementId: "G-T1W7N78M7Y"
});

const db = getFirestore(app);
export default db;